import { createContext, useContext } from "react";
import type { Context } from "react";
import type { ConsentCategories, ConsentState } from "@/lib/consent/types";

export interface ConsentContextValue {
  /** null = unentschieden (Banner zeigen), sonst gespeicherte Einwilligung. */
  state: ConsentState | null;
  /** True, sobald clientseitig gelesen wurde — verhindert SSR-Flash. */
  ready: boolean;
  acceptAll: () => void;
  rejectAll: () => void;
  saveCustom: (categories: ConsentCategories) => void;
  openSettings: () => void;
  closeSettings: () => void;
  isSettingsOpen: boolean;
}

type ConsentGlobalStore = typeof globalThis & {
  __creategy_consent_context__?: Context<ConsentContextValue | null>;
};

const globalStore = globalThis as ConsentGlobalStore;

// HMR-stabile Context-Instanz: Provider und Consumer teilen auch nach
// Fast-Refresh-Invalidierungen dieselbe React-Context-Referenz.
export const ConsentContext =
  globalStore.__creategy_consent_context__ ?? createContext<ConsentContextValue | null>(null);

globalStore.__creategy_consent_context__ = ConsentContext;

export function useConsent() {
  const ctx = useContext(ConsentContext);
  if (!ctx) throw new Error("useConsent must be used within ConsentProvider");
  return ctx;
}

export function useOptionalConsent() {
  return useContext(ConsentContext);
}